/**
 * DS size 체계 마이그레이션 유틸리티.
 *
 * 구 네이밍(xSmall, small, medium, large, xLarge 등)을
 * 신규 Figma 네이밍(xs, sm, md, lg, xl)으로 변환한다.
 * 이미 신규 값이면 그대로 통과시킨다.
 *
 * 운영 앱에서 구 네이밍을 사용하는 코드가 깨지지 않도록
 * 컴포넌트 내부에서 이 함수를 거쳐 recipe에 전달한다.
 */

type LegacySizeMap = {
  xSmall: 'xs';
  small: 'sm';
  medium: 'md';
  large: 'lg';
  xLarge: 'xl';
  normal: 'md';
  mini: 'sm';
  'x-small': 'xs';
};

type LegacySize = keyof LegacySizeMap;

const LEGACY_SIZE_MAP: Record<LegacySize, string> = {
  xSmall: 'xs',
  small: 'sm',
  medium: 'md',
  large: 'lg',
  xLarge: 'xl',
  normal: 'md',
  mini: 'sm',
  'x-small': 'xs',
};

/**
 * 레거시 size 값을 신규 Figma 체계로 변환.
 * 신규 값(xs, sm, md …)은 그대로 반환한다.
 * 타입 수준에서는 입력 타입을 그대로 유지해 recipe 호환성을 보장한다.
 *
 * @example
 * migrateSize('medium')  // → 'md'
 * migrateSize('md')      // → 'md'
 * migrateSize(undefined) // → undefined
 */
export function migrateSize<T extends string | undefined>(size: T): T {
  if (size === undefined) {
    return undefined as T;
  }
  return (LEGACY_SIZE_MAP[size as LegacySize] ?? size) as T;
}
